<template>
  <div class="speaker-card">
    <picture>
      <img
        :src="data.image"
        v-if="data.image"
        :alt="data.title"
        loading="lazy"
      />
      <div v-else class="placeholder" />
    </picture>
    <div class="text-container">
      <h5 class="title">{{ data.title }}</h5>
      <p>
        {{ truncatedText }}
        <button v-if="isTruncated" @click="toggleOpen">
          {{ open ? "Les mindre" : "Les mer" }}
        </button>
      </p>
      <a
        v-if="data.url && data.url.value"
        :href="data.url.value"
        rel="nofollow, noreferrer"
      >
        {{ data.url.customText }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      open: false
    };
  },
  props: ["data"],
  computed: {
    isTruncated() {
      return this.data.text.length > 180; // Adjust the length as needed
    },
    truncatedText() {
      return this.open || !this.isTruncated
        ? this.data.text
        : this.data.text.slice(0, 180) + "..."; // Adjust the length as needed
    }
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    }
  }
};
</script>
<style scoped>
.speaker-card {
  color: #2f4286;

  picture {
    img {
      aspect-ratio: 4/3;
      object-fit: scale-down;
      width: 100%;
      background: white;
    }

    .placeholder {
      width: 100%;
      aspect-ratio: 4/3;
      background: #ccc;
    }
  }

  .text-container {
    margin-top: 15px;

    a.link {
      text-decoration: none;

      h5.title {
        margin-bottom: 10px;
        color: #2f4286;
      }
    }

    .title {
      font-weight: bold;
      font-size: 25px;
      line-height: 30px;
    }

    p {
      font-size: 16px;
      line-height: 20px;

      button {
        font-weight: normal;
        color: #2f4286;
        text-decoration: underline;
        padding: 0;
      }
    }

    a {
      font-weight: bold;
      color: #2f4286;
      text-decoration: underline;
    }
  }
}
</style>
